<template>
  <div class="content-info" v-show="contentInfoShow">
    <div class="info-title">
      <span class="info-title--prefix"></span>
      <span class="info-title--content">详情</span>
      <img src="@/assets/myImg/1/icon-close.png" class="info-title--sufix" @click="closeOverLay()" />
    </div>
    <div class="info-content">
      <div id="info-popup-content-page">
        <div class="info-content-item" v-for="item in infoData" :key="item.id">
          <span class="info-content-item-name">{{ item.name }}:</span>
          <span v-if="item.hyperlinkUrl" class="info-content-item-value-hyperlink" @click="handleHyperlink(item)">
            {{ item.value }}
          </span>
          <span v-else-if="item.clickable" class="info-content-item-value-clickable"
            @click="handleClickableField(item)">
            {{ item.value }}
          </span>
          <span v-else class="info-content-item-value">
            {{ item.value }}
          </span>
        </div>
      </div>
      <div class="water-control-btn-wrapper" style=" border-top: 1px solid rgba(255, 255, 255, 0.1);">
        <a-button type="primary" block @click="printpage">
          打印详情
        </a-button>
      </div>

      <!-- 区域停水管控按钮 - 仅在管线要素时显示 -->
      <div v-if="showWaterControlBtn" class="water-control-btn-wrapper" style="margin-top: 5px !important;">
        <a-button type="primary" block @click="handleWaterControl">
          区域停水管控
        </a-button>
      </div>

    </div>
    <water-number-modal ref="WaterNumberModal" style="z-index: 9999;"></water-number-modal>
  </div>
</template>
<script>
import { getFeatureConfig, valveTypes } from '../mapModule/featureConfig.js'
import WaterNumberModal from '../WaterNumberModal'
import printJs from 'print-js'
export default {
  components: {
    WaterNumberModal
  },
  name: 'InfoMap',
  data () {
    return {
      contentInfoShow: false,
      infoData: [],
      showWaterControlBtn: false, // 是否显示区域停水管控按钮
      currentFeature: null // 当前选中的要素
    }
  },
  methods: {
    handleFeatureData (feature) {
      console.log('要素数据:', feature)
      this.loadFeatureData(feature)
    },
    loadFeatureData (feature) {
      console.log('要素ID:', feature.id);
      this.contentInfoShow = true;
      this.currentFeature = feature; // 保存当前要素

      // 使用封装的ID判断方法
      const id = this.parseFeatureId(feature);

      // 判断是否显示区域停水管控按钮（仅管线显示）
      this.showWaterControlBtn = feature.id.includes('gis_pipe_line');
      console.log('是否显示停水管控按钮:', this.showWaterControlBtn);

      // 根据要素ID获取配置
      const config = getFeatureConfig(id);
      if (config) {
        console.log('找到要素配置:', config);
        this.handleFeature(feature.properties, config);
      } else {
        console.log('未找到对应的要素配置');
        this.infoData = [];
      }
    },

    // 解析要素ID，返回标准化的要素类型
    parseFeatureId (feature) {
      const { id, properties } = feature

      if (id.includes('gis_pipe_line')) {
        return 'gis_pipe_line'
      }

      if (id.includes('gis_pipe_network')) {
        const { appendage, structure } = properties || {}

        if (appendage && valveTypes[appendage]) {
          return valveTypes[appendage]
        }

        if (appendage) {
          return 'gis_pipe_network_appendage'
        }

        if (structure) {
          return 'gis_pipe_network_structure'
        }

        return 'gis_pipe_network'
      }

      return id
    },

    // 处理管线要素
    handleFeature (data, elements) {
      console.log('处理管线要素数据:', data);

      this.infoData = elements.map(item => {
        const rawValue = data[item.id] || '暂无数据';
        let displayValue = rawValue;
        let hyperlinkUrl = '';

        // 应用格式化规则
        if (item.rule && rawValue !== '暂无数据') {
          displayValue = this.formatValue(rawValue, item.rule);
        }

        // 构建超链接URL
        if (item.hyperlink) {
          hyperlinkUrl = this.buildHyperlinkUrl(item.hyperlink, data);
        }

        // 处理可点击字段的value设置
        let clickableConfig = item.clickable;
        if (clickableConfig && typeof clickableConfig === 'object' && clickableConfig.type) {
          clickableConfig = {
            ...clickableConfig,
            value: data[clickableConfig.type] || ''
          };
        }

        return {
          ...item,
          value: displayValue,
          hyperlinkUrl: hyperlinkUrl,
          clickable: clickableConfig
        };
      });

      console.log('处理后的信息数据:', this.infoData);
    },

    // 格式化值
    formatValue (value, rule) {
      if (rule.position === 'before') {
        return rule.text + value;
      } else if (rule.position === 'after') {
        return value + rule.text;
      }
      return value;
    },

    // 构建超链接URL
    buildHyperlinkUrl (hyperlink, data) {
      let url = hyperlink.url;
      hyperlink.value.forEach(fieldName => {
        const fieldValue = data[fieldName] || '';
        url = url.replace(/=([^&]*)/, '=' + fieldValue);
      });
      return url;
    },
    handleHyperlink (item) {
      console.log('点击了超链接:', item);
      if (item.hyperlink.way === 'open') {
        window.open(item.hyperlinkUrl);
      }
    },

    // 处理可点击字段
    handleClickableField (item) {
      console.log('点击了可点击字段:', item);

      // 根据字段类型执行不同的操作
      switch (item.id) {
        case 'water_count':
          // 水表数量点击处理
          this.handleWaterCountClick(item);
          break;

      }
    },

    // 处理水表数量点击
    handleWaterCountClick (item) {
      console.log('水表数量被点击:', item);

      // 获取可点击配置中的value值（即class_no的值）
      const classNo = item.clickable?.value || '';
      console.log('获取到的class_no值:', classNo);
      this.$refs.WaterNumberModal.edit(classNo)
    },

    // 处理区域停水管控按钮点击
    handleWaterControl () {
      console.log('区域停水管控按钮被点击');
      console.log('当前要素:', this.currentFeature);

      // 提取管线ID（从 gis_pipe_line.1729391543024979969 中提取数值部分）
      const pipelineId = this.extractPipelineId(this.currentFeature.id);
      console.log('提取的管线ID:', pipelineId);

      // 向父组件发送事件，打开停水管控抽屉，传递管线ID
      this.$emit('water-control', {
        feature: this.currentFeature,
        pipelineId: pipelineId
      });
    },

    // 提取管线ID
    extractPipelineId (featureId) {
      if (!featureId) return null;

      // 从 gis_pipe_line.1729391543024979969 中提取点号后面的数值
      const parts = featureId.split('.');
      if (parts.length > 1) {
        return parts[1]; // 返回点号后面的部分
      }

      return null;
    },

    closeOverLay () {
      this.contentInfoShow = false
      this.showWaterControlBtn = false // 重置按钮显示状态
      this.currentFeature = null // 清空当前要素
      // 告知父组件清除矢量图层
      this.$emit('close-overlay')
    },
    printpage () {
      const style = `
        @page { margin: 10mm; }
        .info-content-item {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          line-height: 30px !important;
          page-break-inside: avoid !important;
          width: 100% !important;
        }
        .info-content-item-name {
          font-size: 14px !important;
          color: #000 !important;
          flex-shrink: 0 !important;
          margin-right: 10px !important;
        }
        .info-content-item-value,
        .info-content-item-value-hyperlink,
        .info-content-item-value-clickable {
          font-size: 14px !important;
          color: #000 !important;
          text-align: right !important;
          word-break: break-all !important;
        }
      `
      printJs({
        printable: 'info-popup-content-page',
        type: 'html',
        scanStyles: false,
        style: style,
        header: '<h3 style="text-align: center; margin: 10px 0;">详情信息</h3>'
      })
    },
  }
}
</script>
<style lang="less" scoped>
.content-info {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  top: 3%;
  right: 24px;
  z-index: 5;
  width: 240px;

  .info-title {
    background-image: linear-gradient(270deg, rgba(7, 142, 231, 0.959) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    display: flex;
    height: 46px;
    align-items: center;
    color: #ffffff;
    // margin-bottom: 9px;

    .info-title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .info-title--content {
      width: 100%;
      flex: 1;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #ffffff;
      font-weight: 600;
      line-height: 12px;
      height: 12px;
    }

    .info-title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }

  .info-content {
    padding: 12px;

    .info-content-item {
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info-content-item-name {
      font-size: 14px;
      color: #ffffff;
    }

    .info-content-item-value {
      font-size: 14px;
      color: #ffffff;
    }

    .info-content-item-value-hyperlink {
      color: #0890f2;
      cursor: pointer;
    }

    .info-content-item-value-clickable {
      color: #52c41a;
      cursor: pointer;
      text-decoration: underline;
      transition: all 0.3s ease;

      &:hover {
        color: #389e0d;
        text-decoration: none;
      }
    }
  }


  .water-control-btn-wrapper {
    margin-top: 10px !important;
    padding-top: 12px;

    :deep(.ant-btn) {
      background: linear-gradient(135deg, #0890f2, #078ee7);
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      height: 36px;
      box-shadow: 0 2px 8px rgba(8, 144, 242, 0.3);
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(135deg, #078ee7, #0681d6);
        box-shadow: 0 4px 12px rgba(8, 144, 242, 0.5);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}
</style>